import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import "./styles/PinView.scss";
import Spacer from "../components/Divider/Spacer";
import { config, colors } from "../constants";
import ColorButton from "../components/Buttons/ColorButton";

const VIEWS = {
  SUCCESS: 1,
  ERROR: 2,
  INPUT: 3
};

const defaultState = {
  pin: [],
  currentView: VIEWS.INPUT,
  pinError: undefined,
  successPayload: undefined,
  loading: false
};

class PinView extends React.Component {
  state = {
    ...defaultState
  };

  componentWillReceiveProps(nextProps) {
    // reset view on url change
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setState(defaultState);
    }
  }

  handleChange = (i, event) => {
    // update pin state
    const newPin = this.state.pin;
    newPin[i] = event.target.value;
    this.setState({ pin: newPin });

    // focus on next input
    if (document.getElementById(`codeInput${i}`).value.length !== 0) {
      if (i >= config.PIN_LENGTH - 1) {
        document.getElementById(`codeInput${config.PIN_LENGTH - 1}`).blur();
      } else {
        const nextInput = document.getElementById(`codeInput${i + 1}`);
        nextInput.focus();
      }
    }
  };

  handleFocus = (i, event) => {
    if (event.target.value !== "") {
      // clear input
      event.target.value = "";

      // update state var
      const newPin = this.state.pin;
      newPin[i] = "";
      this.setState({ pin: newPin });
    }
  };

  handleSubmitCode = async () => {
    const submittedPin = this.state.pin.join("").toUpperCase();

    this.setState({ loading: true });

    // fetch data
    const result = await fetch(
      `${config.API_ENDPOINT}/api/merchant/${
        this.props.isPickup ? "deliverPackage" : "addUserPackage"
      }/${submittedPin}?token=${this.props.auth.token}`
    ).then(res => res.json());

    // update view for success / fail
    this.setState({
      loading: false,
      currentView: result.status === 200 ? VIEWS.SUCCESS : VIEWS.ERROR,
      pinError: result.status > 200 ? result.message : undefined,
      successPayload:
        result.status === 200 && result.payload ? result.payload : undefined
    });
  };

  render() {
    const { isPickup } = this.props;

    if (this.state.currentView === VIEWS.SUCCESS) {
      return (
        <div id="pinView">
          {isPickup ? <h2>USER FOUND</h2> : <h2>PACKAGE ACCEPTED!</h2>}
          <Spacer height={20} />
          <div className="iconDiv">
            <img src={require("../assets/icons/checked.png")} alt="checkmark" />
          </div>
          <Spacer height={10} />
          {isPickup && (
            <p className="subText">{`There are ${
              this.state.successPayload.numPackages
            } packages in your inventory for ${
              this.state.successPayload.recipientName
            }.`}</p>
          )}
          <Spacer height={10} />
          <ColorButton
            text={isPickup ? "Retrieve more" : "Add another package"}
            onClick={() => this.setState(defaultState)}
            color={colors.lightBlue}
          />
          <ColorButton
            text="Return to home"
            onClick={() => this.props.history.push("/home")}
            color={colors.lightBlue}
          />
        </div>
      );
    } else if (this.state.currentView === VIEWS.ERROR) {
      return (
        <div id="pinView">
          <h2>AN ERROR HAS OCCURRED</h2>
          <Spacer height={20} />
          <div className="iconDiv">
            <img src={require("../assets/icons/error2.png")} alt="error icon" />
          </div>
          <Spacer height={10} />
          <p className="subText">{this.state.pinError}</p>
          <Spacer height={10} />
          <ColorButton
            text="Try again"
            onClick={() => this.setState(defaultState)}
            color={colors.lightBlue}
          />
          <ColorButton
            text="Return to home"
            onClick={() => this.props.history.push("/home")}
            color={colors.lightBlue}
          />
        </div>
      );
    }

    return (
      <div id="pinView">
        <h2>
          ENTER {this.props.isPickup ? "DROPOFF CODE" : "SAFEBOX USER ID"}
        </h2>
        <Spacer height={20} />
        <div className="centerFlex">
          {[...Array(config.PIN_LENGTH)].map((e, i) => (
            <input
              key={i}
              id={`codeInput${i}`}
              size={1}
              maxLength={1}
              value={this.state.pin[i]}
              onFocus={event => this.handleFocus(i, event)}
              onChange={event => this.handleChange(i, event)}
            />
          ))}
        </div>
        <Spacer height={30} />
        <ColorButton
          text="Submit"
          onClick={this.handleSubmitCode}
          color={colors.lightGreen}
          loading={this.state.loading}
        />
      </div>
    );
  }
}

PinView.propTypes = {
  isPickup: PropTypes.bool
};

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PinView);
